// Navigation hints only. Destination routes independently recheck all admission.
const destinations=new Map([['/publishing/signup','Create publisher'],['/publishing/','Publisher dashboard']]);
const generations=new WeakMap();
export async function LoadPublisherNavigation({root=document,fetchImpl=fetch,eligible=true}={})
	{
	const links=Array.from(root.querySelectorAll('[data-publisher-navigation]'));
	const tickets=links.map(link=>{const ticket=(generations.get(link)||0)+1;generations.set(link,ticket);link.hidden=true;link.style.display='none';link.removeAttribute('href');return ticket;});
	if (!eligible||!links.length) return null;
	const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),4000);
	try
		{
		const response=await fetchImpl('/api/publishing/v1/navigation',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
		if (!response.ok) return null;
		const entry=(await response.json())?.data?.publisher;
		if (!entry||!destinations.has(entry.href)) return null;
		links.forEach((link,index)=>
			{
			if (generations.get(link)!==tickets[index]) return;
			link.setAttribute('href',entry.href);link.textContent=destinations.get(entry.href);link.hidden=false;link.style.display='';
			});
		return entry.href;
		}
	catch {return null;}
	finally {clearTimeout(timer);}
	}
